/**
 * What the studio form says beyond `start.ts` (boards L4 and L5), and the rail's
 * way into the wish screen (C2, left). The studio form's title, labels and the
 * two blocked sentences are still `start.ts`'s; these are the sentences the
 * redesign added, verbatim from the boards.
 */

export const STUDIO_FIGURE_ALT = "Djinn, a figure of light";
export const STUDIO_FORM_LABEL = "Name your studio";
export const STUDIO_NEXT = "Next: what you wish to build.";

/** The slug field, while it still follows the name (L4). */
export const STUDIO_SLUG_FOLLOWS = "filled from the name";
export const STUDIO_SLUG_PERMANENT =
  "Letters, numbers and dashes. It is part of your studio's links, and it can't be changed once the studio exists.";

/** The slug field after the person has edited it (L5, "Slug edited by hand"). */
export const STUDIO_SLUG_EDITED =
  "Edited by you, so it no longer follows the name. Letters, numbers and dashes. It is part of your studio's links.";

/** The studio's slug is empty or has no letter or number to start it (L5, "Slug emptied"). */
export const STUDIO_SLUG_EMPTY_MARK = "—";

/** The rail row that opens the wish screen from anywhere (C2, left). */
export const BUILD_WITH_DJINN = "Build with Djinn";
